import styled from 'styled-components';

export const PlaceholderIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme['color.primary']};
  opacity: 0.3;
  margin: 1px 15px 1px 1px;
  flex: none;
`;

export const PlaceholderText = styled.div`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  margin: 5px 0;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => props.theme['modal.description.color']};
  opacity: 0.3;
  flex: 1;
`;
